import React from 'react';

interface Props {
  alt?: string;
  src: string;
  width?: number | undefined;
}

const Logo = ({ alt = 'logo', width = undefined, src }: Props) => {
  return <img id="header--logo" className="img-responsive" width={`${width}px`} src={src} alt={alt} />;
};

export default Logo;
